module.exports = __webpack_public_path__ + "static/media/FANTOM.3ce0ecb0.svg";